document.querySelectorAll('.velouria-giftcard__form-wrapper').forEach((wrapper) => {
  const variantIdInput = wrapper.querySelector('[name="id"]');
  const submitPrice = wrapper.querySelector('.velouria-giftcard__submit-price');
  const options = wrapper.querySelectorAll('.velouria-giftcard__option');

  options.forEach((option) => {
    option.addEventListener('click', () => {
      options.forEach((other) => {
        other.classList.remove('is-selected');
        other.setAttribute('aria-pressed', 'false');
      });
      option.classList.add('is-selected');
      option.setAttribute('aria-pressed', 'true');

      if (variantIdInput) variantIdInput.value = option.dataset.variantId;
      if (submitPrice) submitPrice.textContent = option.dataset.variantPrice;
    });
  });
});
